module.exports = __webpack_public_path__ + "static/media/icon-leads-white.01472738.svg";